import { render, staticRenderFns } from "./CourseCompareItem.vue?vue&type=template&id=edd58270&"
import script from "./CourseCompareItem.vue?vue&type=script&lang=js&"
export * from "./CourseCompareItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports